module.exports = __webpack_public_path__ + "img/not_started.0f2037a3.png";